import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { VatRateDto } from "./vatRateDto.model";

export class VatRateTypeDto {
    idVatRateTypePkDto?: {
        vatRateId?: number,
        startDate: string
    };
    endDate?: string;
    vatPercentage?: number;
    vatRateDto?: VatRateDto;

    constructor(data?: Partial<VatRateTypeDto>) {
        Object.assign(this, data);
    }
}

export class VatRateTypeResponse {
    listVatRateType: VatRateTypeDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class VatRateTypeRequest {
    vatRateTypeDto: VatRateTypeDto = new VatRateTypeDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}